const dataFaq = [
    {
        title: 'Tired of complicated website support?',
        text: 'Join my clients who got started with just a 3 minute call. No tech experience needed, I can show exactly how it works before you pay a penny.',
        show: 'true'
    },
    {
        title: 'How to start a web project if you Want To Launch in 24 Hours?',
        text: 'First things to do are secure your URL (website address), and getting your website copy(text) written and collected.',

    },
    {
        title: 'Why web apps are so popular?',
        text: 'Web apps shine when users log in daily and manipulate data. Websites win for marketing, content, and first impressions. If your idea works as a pdf, start with a website.'
    },
    {
        title: 'How do you make web development easily?',
        text: 'We start simple and launch fast. Then improve based on real user data. I can utilize proven templates to minimize technical headaches. Easy development means seeing progress weekly and launching something the actually works.'
    },
]

export default dataFaq;